/* ============================================================
   NovaBreak Card Show — binder.js
   The 12-pocket binder engine. Mount on any element with:
     <div data-nb-binder data-collection="HANDLE" ...>
   Uses NB helpers from global.js.
   ============================================================ */
(function () {
  const NB = window.NB;

  function initBinder(ROOT) {
    const $ = k => ROOT.querySelector('[data-bcs="' + k + '"]');
    const COLLECTION = ROOT.dataset.collection || 'all';
    const PER_PAGE = 12;
    const QUICKVIEW = ROOT.dataset.quickview !== 'false';
    const ACCENT = ROOT.dataset.accent || '';
    let INVENTORY = {};
    try {
      const invEl = $('inventoryJson');
      INVENTORY = invEl && invEl.textContent ? JSON.parse(invEl.textContent) : {};
    } catch (e) { INVENTORY = {}; }
    /* Share this reliable Liquid inventory with the cart so its quantity caps
       are correct for cards bought from this binder. */
    if (NB.registerStock) NB.registerStock(INVENTORY);

    if (ACCENT && NB.applyAccent) NB.applyAccent(ACCENT, ROOT);

    let CARDS = [], filtered = [], spread = 0, busy = false;

    /* ---------- Load products ---------- */
    async function loadProducts() {
      let page = 1, out = [];
      while (page <= 8) { /* up to 2000 products */
        const res = await fetch('/collections/' + COLLECTION + '/products.json?limit=250&page=' + page);
        if (!res.ok) break;
        const data = await res.json();
        out = out.concat(data.products || []);
        if (!data.products || data.products.length < 250) break;
        page++;
      }
      CARDS = out.map(NB.toCard);
      applyEmbeddedInventory(CARDS);
      buildFilters();
      applyPrefilters();   /* set dropdowns/search from URL or parsed query */
      applyFilters();
      if ($('loading')) $('loading').style.display = 'none';
    }

    function applyEmbeddedInventory(cards) {
      if (!INVENTORY || !cards) return;
      cards.forEach(card => {
        (card.variants || []).forEach(v => {
          const inv = INVENTORY[String(v.id)];
          if (!inv) return;
          v.stock = Number.isFinite(Number(inv.stock)) ? Math.max(0, parseInt(inv.stock, 10)) : null;
          v.oversell = !inv.tracked || String(inv.policy || 'deny').toLowerCase() === 'continue';
          v.available = !!inv.available;
          v.hasLiquidStock = true;
        });
        card.sold = !(card.variants || []).some(v => v.available);
      });
    }

    function buildFilters() {
      const fill = (sel, vals) => { if (!sel) return; vals.filter(Boolean).forEach(v => {
        const o = document.createElement('option'); o.value = v; o.textContent = v; sel.appendChild(o);
      });};
      fill($('fTcg'), [...new Set(CARDS.map(c => c.tcg))].sort());
      fill($('fSet'), [...new Set(CARDS.map(c => c.set))].sort());
      /* Era filter (QA request): appears only when products carry era: tags.
         Selecting an era narrows the Set dropdown to that era's sets. */
      const eras = [...new Set(CARDS.map(c => c.era))].filter(Boolean).sort();
      if ($('fEra') && eras.length) {
        fill($('fEra'), eras);
        $('fEra').hidden = false;
        $('fEra').addEventListener('change', () => {
          const er = $('fEra').value;
          const keep = $('fSet').value;
          const sets = [...new Set(CARDS.filter(c => !er || c.era === er).map(c => c.set))].filter(Boolean).sort();
          $('fSet').innerHTML = '<option value="">All Sets</option>';
          fill($('fSet'), sets);
          if (sets.includes(keep)) $('fSet').value = keep;
        });
      }
      const conds = [...new Set(CARDS.flatMap(c => c.variants.map(v => v.cond)))].filter(Boolean);
      conds.sort((a, b) => {
        const ia = NB.COND_ORDER.indexOf(a), ib = NB.COND_ORDER.indexOf(b);
        return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
      });
      fill($('fCond'), conds);
      const grades = [...new Set(CARDS.flatMap(c => c.variants.map(v => v.grade)))].filter(Boolean).sort();
      fill($('fGrade'), grades);
    }

    function applyPrefilters() {
      const params = new URLSearchParams(location.search);
      const setSel = v => { const el = $(v[0]); if (el && v[1]) {
        /* case-insensitive match against existing options */
        const opt = [...el.options].find(o => o.value.toLowerCase() === String(v[1]).toLowerCase());
        if (opt) el.value = opt.value;
      }};
      /* Either a raw ?q= (free text into the search box) or structured params */
      const rawQ = params.get('q');
      if (rawQ && $('q')) {
        const parsed = NB.parseQuery ? NB.parseQuery(rawQ, CARDS) : null;
        if (parsed) {
          if (parsed.set) setSel(['fSet', parsed.set]);
          if (parsed.tcg) setSel(['fTcg', parsed.tcg]);
          if (parsed.cond) setSel(['fCond', parsed.cond]);
          if (parsed.grade) setSel(['fGrade', parsed.grade]);
          if ($('q')) $('q').value = parsed.text || '';
          showSearchSummary(rawQ, parsed);
        } else if ($('q')) {
          $('q').value = rawQ;
        }
      } else {
        setSel(['fEra', params.get('era')]);
        setSel(['fSet', params.get('set')]);
        setSel(['fTcg', params.get('tcg')]);
        setSel(['fCond', params.get('cond')]);
        setSel(['fGrade', params.get('grade')]);
        if (params.get('name') && $('q')) $('q').value = params.get('name');
      }
    }

    function showSearchSummary(rawQ, parsed) {
      const head = ROOT.querySelector('.nb-binder-head');
      if (!head) return;
      const bits = [];
      if (parsed.text) bits.push('"' + parsed.text + '"');
      if (parsed.set) bits.push('set: ' + parsed.set);
      if (parsed.tcg) bits.push(parsed.tcg);
      if (parsed.cond) bits.push(parsed.cond);
      if (parsed.grade) bits.push(parsed.grade);
      let note = head.querySelector('.nb-search-summary');
      if (!note) { note = document.createElement('p'); note.className = 'nb-search-summary'; head.appendChild(note); }
      note.innerHTML = 'Showing ' + NB.esc(bits.join(' · ') || rawQ) +
        ' <button type="button" class="nb-search-clear" data-bcs="clearSearch">clear</button>';
    }

    function applyFilters() {
      const val = k => $(k) ? $(k).value : '';
      const q = val('q').trim().toLowerCase();
      const t = val('fTcg'), s = val('fSet'), cd = val('fCond'), gr = val('fGrade'), er = val('fEra');
      const srt = val('sort') || 'az';
      const bv = NB.bestVar;
      function matchCard(c, q) {
        /* Free text now matches the card's chips too — name + set + game + finish +
           collector number — with token-AND. So "surging" and "surging sparks" both
           find Surging Sparks cards, and "pikachu surging" narrows to both. */
        const hay = ((c.name || '') + ' ' + (c.set || '') + ' ' + (c.era || '') + ' ' + (c.tcg || '') + ' ' +
                     (c.finish || '') + ' ' + (c.numStr || '')).toLowerCase();
        return q.split(/\s+/).every(w => !w || hay.includes(w));
      }
      filtered = CARDS.filter(c =>
        (!q || matchCard(c, q)) &&
        (!t || c.tcg === t) && (!s || c.set === s) && (!er || c.era === er) &&
        (!cd || c.variants.some(v => v.cond === cd && v.available)) &&
        (!gr || c.variants.some(v => v.grade === gr && v.available)));
      const fns = {
        az: (a, b) => a.name.localeCompare(b.name), za: (a, b) => b.name.localeCompare(a.name),
        plo: (a, b) => bv(a).price - bv(b).price, phi: (a, b) => bv(b).price - bv(a).price,
        number: (a, b) => (a.num - b.num) || (a.idx - b.idx)
      };
      filtered.sort(fns[srt]);
      spread = 0; render();
    }
    let lastParsed = '';
    function onSearchInput() {
      const el = $('q'); if (!el) return;
      const raw = el.value.trim();
      /* Only run the parser when the text contains a connective/structured hint,
         otherwise treat as a plain name filter (handled by applyFilters). */
      if (raw && /\b(from|in|psa|bgs|cgc|sgc|near mint|lightly|moderately|heavily|damaged|nm|lp|mp|hp)\b/i.test(raw)) {
        const parsed = NB.parseQuery(raw, CARDS);
        if (parsed && (parsed.set || parsed.tcg || parsed.cond || parsed.grade)) {
          if (parsed.set) { const o=[...$('fSet').options].find(x=>x.value.toLowerCase()===parsed.set.toLowerCase()); if(o)$('fSet').value=o.value; }
          if (parsed.tcg && $('fTcg')) { const o=[...$('fTcg').options].find(x=>x.value.toLowerCase()===parsed.tcg.toLowerCase()); if(o)$('fTcg').value=o.value; }
          if (parsed.cond && $('fCond')) { const o=[...$('fCond').options].find(x=>x.value===parsed.cond); if(o)$('fCond').value=parsed.cond; }
          if (parsed.grade && $('fGrade')) { const o=[...$('fGrade').options].find(x=>x.value.toLowerCase()===parsed.grade.toLowerCase()); if(o)$('fGrade').value=o.value; }
          el.value = parsed.text || '';
        }
      }
      applyFilters();
    }
    ['fTcg', 'fEra', 'fSet', 'fCond', 'fGrade', 'sort'].forEach(k => {
      const el = $(k); if (el) el.addEventListener('input', applyFilters);
    });
    if ($('q')) $('q').addEventListener('change', onSearchInput);
    if ($('q')) $('q').addEventListener('input', applyFilters);
    ROOT.addEventListener('click', e => {
      if (e.target.closest('[data-bcs="clearSearch"]')) {
        ['q','fTcg','fSet','fCond','fGrade'].forEach(k => { const el = $(k); if (el) el.value = (el.tagName === 'SELECT') ? '' : ''; });
        const note = ROOT.querySelector('.nb-search-summary'); if (note) note.remove();
        history.replaceState(null, '', location.pathname);
        applyFilters();
      }
    });

    /* ---------- Rendering ---------- */
    function zoomBtn(c) {
      if (!(window.NB && NB.Inspect) || !c.img) return '';
      const faces = [{ src: NB.sized(c.img, 2048), label: 'Front' }];
      if (c.back) faces.push({ src: NB.sized(c.back, 2048), label: 'Back' });
      return '<button type="button" class="nb-zoombtn nb-zoombtn--sm" data-nb-inspect' +
        ' data-faces="' + NB.esc(JSON.stringify(faces)) + '"' +
        ' aria-label="Inspect ' + NB.esc(c.name) + ' — zoom to check condition">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg></button>';
    }

    function pocketHTML(c, slot) {
      if (!c) return '<div class="nb-pocket empty" aria-hidden="true"></div>';
      const bv = NB.bestVar(c);
      const img = c.img ? '<img loading="lazy" src="' + NB.sized(c.img, 420) + '" alt="' + NB.esc(c.name) + '">' : '';
      const tag = QUICKVIEW ? 'div' : 'a';
      const href = QUICKVIEW ? '' : ' href="' + c.url + '"';
      const label = c.isSlab && bv.grade ? bv.grade : bv.cond;
      const chips = NB.chipsHTML(c);
      return '<' + tag + href + ' class="nb-pocket ' + (c.sold ? 'is-sold ' : '') + (c.isSlab ? 'is-slab' : '') + '" tabindex="0" role="button"' +
        ' aria-label="' + NB.esc(c.name) + (label ? ', ' + NB.esc(label) : '') + ', ' + NB.MONEY(bv.price) + (c.sold ? ', sold' : '') + '" data-id="' + c.id + '">' +
        '<div class="art">' +
          '<span class="slot">#' + slot + '</span>' + NB.badgeHTML(c) +
          img +
          '<div class="soldout"><span>Sold</span></div>' +
          (window.NB && NB.Wants ? NB.Wants.pocketHeart(c) : '') +
          zoomBtn(c) +
        '</div>' +
        '<div class="meta">' +
          '<div class="nm-wrap"><span class="nm">' + NB.esc(c.name) + '</span>' +
          (chips ? '<span class="nb-chips">' + chips + '</span>' : '') + '</div>' +
          '<span class="pr">' + NB.MONEY(bv.price) + '</span>' +
        '</div>' +
        '</' + tag + '>';
    }
    function pageHTML(p) {
      if (p < 1) return '';
      const start = (p - 1) * PER_PAGE, cards = filtered.slice(start, start + PER_PAGE);
      if (!cards.length && p > 1) return '';
      let h = '';
      for (let i = 0; i < PER_PAGE; i++) h += pocketHTML(cards[i], start + i + 1);
      return h;
    }
    const totalPages = () => Math.max(1, Math.ceil(filtered.length / PER_PAGE));
    const leftP = () => spread * 2 + 1, rightP = () => spread * 2 + 2;
    const isMobile = () => matchMedia('(max-width:820px)').matches;

    function render() {
      if ($('empty')) $('empty').classList.toggle('show', !filtered.length && CARDS.length > 0);
      if (isMobile()) {
        const p = spread + 1;
        $('pgR').innerHTML = pageHTML(p);
        $('pnR').textContent = p <= totalPages() ? 'Page ' + p : '';
        $('spreadLabel').textContent = 'Page ' + Math.min(p, totalPages()) + ' of ' + totalPages();
        $('prev').disabled = spread === 0; $('next').disabled = p >= totalPages();
      } else {
        $('pgL').innerHTML = pageHTML(leftP()); $('pgR').innerHTML = pageHTML(rightP());
        $('pnL').textContent = leftP() <= totalPages() ? 'Page ' + leftP() : '';
        $('pnR').textContent = rightP() <= totalPages() ? 'Page ' + rightP() : '';
        $('spreadLabel').textContent = 'Pages ' + leftP() + '–' + Math.min(rightP(), totalPages()) + ' of ' + totalPages();
        $('prev').disabled = spread === 0; $('next').disabled = rightP() >= totalPages();
      }
    }

    /* ---------- Binder flip ---------- */
    function flip(dir) {
      if (busy) return;
      if (isMobile()) { spread += dir; render(); return; }
      busy = true;
      const binder = $('binder');
      const fl = document.createElement('div');
      fl.className = 'nb-flipper ' + (dir > 0 ? 'from-right' : 'from-left');
      if (dir > 0) {
        fl.innerHTML =
          '<div class="nb-face front"><div class="nb-page right"><div class="nb-pockets">' + pageHTML(rightP()) + '</div></div></div>' +
          '<div class="nb-face back"><div class="nb-page left"><div class="nb-pockets">' + pageHTML(leftP() + 2) + '</div></div></div>';
        $('pgR').innerHTML = pageHTML(rightP() + 2);
        $('pnR').textContent = (rightP() + 2) <= totalPages() ? 'Page ' + (rightP() + 2) : '';
      } else {
        fl.innerHTML =
          '<div class="nb-face front"><div class="nb-page left"><div class="nb-pockets">' + pageHTML(leftP()) + '</div></div></div>' +
          '<div class="nb-face back"><div class="nb-page right"><div class="nb-pockets">' + pageHTML(rightP() - 2) + '</div></div></div>';
        $('pgL').innerHTML = pageHTML(leftP() - 2);
        $('pnL').textContent = (leftP() - 2) >= 1 ? 'Page ' + (leftP() - 2) : '';
      }
      binder.appendChild(fl);
      requestAnimationFrame(() => binder.classList.add('flipping'));
      const done = () => { spread += dir; binder.classList.remove('flipping'); fl.remove(); busy = false; render(); };
      fl.addEventListener('animationend', done, { once: true });
      setTimeout(() => { if (busy) done(); }, 900);
    }
    $('next').addEventListener('click', () => { if (!$('next').disabled) flip(1); });
    $('prev').addEventListener('click', () => { if (!$('prev').disabled) flip(-1); });
    ROOT.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight' && !$('next').disabled) flip(1);
      if (e.key === 'ArrowLeft' && !$('prev').disabled) flip(-1);
    });

    /* ---------- Quick view ---------- */
    let qvCard = null, selVar = null, card3d = null;

    /* Plain-language condition descriptions, collector-friendly. */
    const COND_INFO = {
      NM: { name: 'Near Mint', lines: ['Looks freshly pulled', 'Sharp corners & clean edges', 'No noticeable wear'] },
      LP: { name: 'Light Play', lines: ['Minor edge wear', 'Minor surface imperfections', 'No major creases'] },
      MP: { name: 'Moderate Play', lines: ['Visible edge & corner wear', 'Light scratches or scuffs', 'May show a light crease'] },
      HP: { name: 'Heavy Play', lines: ['Heavy edge & corner wear', 'Surface scratches or whitening', 'May have creases'] },
      DMG: { name: 'Damaged', lines: ['Significant wear or creasing', 'Possible bends, tears, or water marks', 'Priced to reflect condition'] }
    };
    function updateCondExplain() {
      const btn = $('condExplainBtn'), detail = $('condDetail');
      if (!btn || !detail) return;
      if (qvCard.isSlab || !selVar || !selVar.cond) { btn.hidden = true; detail.hidden = true; return; }
      const info = COND_INFO[selVar.cond];
      btn.hidden = !info;
      if (!info) { detail.hidden = true; return; }
      detail.innerHTML = '<strong>' + selVar.cond + ' (' + info.name + ')</strong><ul>' +
        info.lines.map(l => '<li>' + NB.esc(l) + '</li>').join('') + '</ul>';
      /* keep whatever expanded state was set; default collapsed on rebuild */
      detail.hidden = btn.getAttribute('aria-expanded') !== 'true';
    }

    function buildChips() {
      const wrap = $('condChips'); wrap.innerHTML = '';
      selVar = NB.bestVar(qvCard);
      $('condLabel').textContent = qvCard.isSlab ? 'Grade' : 'Condition';
      qvCard.variants.forEach(v => {
        const label = qvCard.isSlab && v.grade ? v.grade : (v.cond || 'Default');
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'nb-chip'; b.disabled = !v.available;
        b.setAttribute('aria-pressed', String(v === selVar));
        b.innerHTML = '<span>' + NB.esc(label) + '</span><small>' + NB.MONEY(v.price) + '</small>';
        b.addEventListener('click', () => {
          selVar = v;
          wrap.querySelectorAll('.nb-chip').forEach(x => x.setAttribute('aria-pressed', 'false'));
          b.setAttribute('aria-pressed', 'true');
          $('qvPrice').textContent = NB.MONEY(v.price);
          $('qvAtc').textContent = 'Add to cart'; $('qvAtc').disabled = false;
          $('qVal').value = 1;
          clampQty();
          updateQtyVisibility();
          syncQuickAddState();
          updateCondExplain();
        });
        wrap.appendChild(b);
      });
      $('qvPrice').textContent = NB.MONEY(selVar.price);
      syncQuickAddState();
      updateCondExplain();
    }

    function pullFromPocket(pocketEl) {
      /* "Take the card out of the binder": clone flies from the pocket
         to the quick-view card. Desktop only; mobile gets the sheet. */
      if (!pocketEl || NB.reduced || matchMedia('(max-width:820px)').matches) return;
      const srcImg = pocketEl.querySelector('img');
      const target = $('card3d');
      if (!srcImg || !target) return;
      const from = srcImg.getBoundingClientRect();
      requestAnimationFrame(() => {
        const to = target.getBoundingClientRect();
        if (!to.width) return;
        const clone = document.createElement('img');
        clone.className = 'nb-qv-pull';
        clone.src = srcImg.src;
        clone.style.left = to.left + 'px';
        clone.style.top = to.top + 'px';
        clone.style.width = to.width + 'px';
        clone.style.height = to.height + 'px';
        document.body.appendChild(clone);
        const dx = from.left - to.left, dy = from.top - to.top;
        const sx = from.width / to.width, sy = from.height / to.height;
        target.classList.add('is-arriving');
        const lift = from.height * 0.35; /* slide up out of the sleeve first */
        clone.animate([
          { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sx + ',' + sy + ')', offset: 0 },
          { transform: 'translate(' + dx + 'px,' + (dy - lift) + 'px) scale(' + sx + ',' + sy + ') rotate(-3deg)', offset: 0.38 },
          { transform: 'translate(0,0) scale(1) rotate(0deg)', offset: 1 }
        ], { duration: 480, easing: 'cubic-bezier(.2,.7,.25,1)' }).onfinish = () => {
          target.classList.remove('is-arriving');
          clone.remove();
        };
        setTimeout(() => { target.classList.remove('is-arriving'); if (clone.isConnected) clone.remove(); }, 800);
      });
    }

    /* Prev/next card within the CURRENT filtered + sorted view — flipping
       through your results without closing the binder (QA-aligned: explicit
       buttons + arrow keys, no gestures). Crosses page boundaries. */
    function qvIndex() { return filtered.findIndex(c => qvCard && c.id === qvCard.id); }
    function qvNav(delta) {
      const i = qvIndex();
      const nxt = filtered[i + delta];
      if (nxt) openQV(nxt.id, null);
    }
    function syncQvNav() {
      const i = qvIndex(), n = filtered.length;
      const many = n > 1 && i >= 0;
      [['qvPrev', i <= 0], ['qvNext', i >= n - 1]].forEach(([k, dis]) => {
        const b = $(k); if (!b) return;
        b.hidden = !many; b.disabled = dis;
      });
      const pos = $('qvPos');
      if (pos) { pos.hidden = !many; if (many) pos.textContent = (i + 1) + ' of ' + n; }
    }

    function openQV(id, pocketEl) {
      qvCard = CARDS.find(c => c.id === id);
      if (!qvCard || qvCard.sold) return;
      qvCard.stockChecked = false;
      /* products.json may not include live inventory counts. Open quickly, then
         hydrate stock in the background; add-to-cart will also wait for this
         before enforcing quantity caps. */
      const root3d = $('card3d');
      root3d.dataset.hasBack = String(!!qvCard.back);
      root3d.classList.toggle('slab', qvCard.isSlab);
      if (!card3d) {
        card3d = NB.Card3D(root3d, {
          onFlip: f => { $('flipBtn').textContent = f ? '↻ View front' : '↻ View back'; }
        });
        $('flipBtn').addEventListener('click', card3d.flip);
      }
      card3d.reset();
      $('qvFront').src = NB.sized(qvCard.img, 800); $('qvFront').alt = qvCard.name;
      $('qvRear').src = qvCard.back ? NB.sized(qvCard.back, 800) : '';
      $('qvRear').alt = qvCard.back ? qvCard.name + ' — back' : '';
      $('flipBtn').hidden = !qvCard.back;
      const qvInspect = $('qvInspect');
      if (qvInspect) {
        const inspectFaces = [{ src: qvCard.img, label: 'Front' }];
        if (qvCard.back) inspectFaces.push({ src: qvCard.back, label: 'Back' });
        qvInspect.setAttribute('data-faces', JSON.stringify(inspectFaces));
      }
      $('flipBtn').textContent = '↻ View back';
      $('qvLink').href = qvCard.url; $('qvLink').textContent = qvCard.name;
      $('qvTags').textContent = [qvCard.tcg, qvCard.set].filter(Boolean).join(' · ');
      buildChips();
      $('qVal').value = 1;
      clampQty();
      updateQtyVisibility();
      const openedCard = qvCard;
      const note = $('qvStockNote');
      if (note) { note.textContent = 'Checking available quantity…'; note.hidden = false; }
      fetchLiveStock(openedCard).then(() => hydrateCartQuantities(openedCard)).then(() => {
        if (qvCard === openedCard) { clampQty(); updateQtyVisibility(); syncQuickAddState(); }
      });
      $('qvAtc').textContent = 'Add to cart';
      if (window.NB && NB.Wants && $('qvWant')) NB.Wants.mountQV($('qvWant'), qvCard);
      syncQvNav();
      $('qvBack').classList.add('open');
      if (NB.lockScroll) NB.lockScroll();
      pullFromPocket(pocketEl);
    }
    function closeQV() {
      if (!$('qvBack').classList.contains('open')) return;
      $('qvBack').classList.remove('open');
      if (NB.unlockScroll) NB.unlockScroll();
    }

    /* Pull live inventory for the open card from /products/HANDLE.js.
       That endpoint exposes inventory_quantity + inventory_management for
       tracked variants, which products.json does not. Merge by variant id,
       then re-clamp the qty selector so the cap reflects real stock. */
    async function fetchLiveStock(card) {
      if (!card || !card.handle) return false;
      try {
        const res = await fetch('/products/' + card.handle + '.js');
        if (!res.ok) { card.stockChecked = true; return false; }
        const data = await res.json();
        (data.variants || []).forEach(lv => {
          const mine = card.variants.find(v => String(v.id) === String(lv.id));
          if (!mine) return;
          /* The Liquid inventory manifest (server-side) is authoritative. The
             public /products.js endpoint withholds/garbles inventory_quantity,
             so only use it to FILL IN variants the manifest didn't cover — never
             to overwrite a reliable manifest value (that caused false "Only 1"). */
          if (!mine.hasLiquidStock) {
            if (Object.prototype.hasOwnProperty.call(lv, 'inventory_quantity') && typeof lv.inventory_quantity === 'number') {
              mine.stock = Math.max(0, parseInt(lv.inventory_quantity, 10));
            }
            if (Object.prototype.hasOwnProperty.call(lv, 'inventory_policy') || Object.prototype.hasOwnProperty.call(lv, 'inventory_management')) {
              const tracked = Object.prototype.hasOwnProperty.call(lv, 'inventory_management') ? lv.inventory_management != null : !mine.oversell;
              const policy = (lv.inventory_policy || 'deny').toLowerCase();
              mine.oversell = !tracked || policy === 'continue';
            }
          }
          /* availability is a reliable real-time signal — safe to refresh. */
          if (Object.prototype.hasOwnProperty.call(lv, 'available')) mine.available = !!lv.available;
        });
        card.stockChecked = true;
        return true;
      } catch (e) {
        card.stockChecked = true;
        return false;
      }
    }


    async function hydrateCartQuantities(card) {
      if (!card || !card.variants) return false;
      try {
        const cart = await NB.getCart();
        card.variants.forEach(v => { v.inCart = 0; });
        (cart.items || []).forEach(item => {
          const mine = card.variants.find(v => String(v.id) === String(item.variant_id));
          if (mine) mine.inCart = (mine.inCart || 0) + (parseInt(item.quantity, 10) || 0);
        });
        card.cartChecked = true;
        return true;
      } catch (e) {
        card.cartChecked = true;
        return false;
      }
    }

    function stockText(n) {
      return n === 1 ? '1 left' : n + ' left';
    }
    /* Mobile sheet: drag the handle down to dismiss */
    function initSheetDrag() {
      const handle = $('qvHandle');
      if (!handle) return;
      const sheet = handle.closest('.nb-qv');
      let startY = 0, dy = 0, dragging = false;
      handle.addEventListener('pointerdown', e => {
        dragging = true; startY = e.clientY; dy = 0;
        sheet.style.transition = 'none';
        handle.setPointerCapture(e.pointerId);
      });
      handle.addEventListener('pointermove', e => {
        if (!dragging) return;
        dy = Math.max(0, e.clientY - startY);
        sheet.style.transform = 'translateY(' + dy + 'px)';
      });
      const release = () => {
        if (!dragging) return;
        dragging = false;
        sheet.style.transition = 'transform .25s cubic-bezier(.2,.7,.25,1)';
        if (dy > 90) {
          sheet.style.transform = 'translateY(100%)';
          setTimeout(() => { closeQV(); sheet.style.transform = ''; sheet.style.transition = ''; }, 240);
        } else {
          sheet.style.transform = '';
          setTimeout(() => { sheet.style.transition = ''; }, 260);
        }
      };
      handle.addEventListener('pointerup', release);
      handle.addEventListener('pointercancel', release);
    }

    /* Only show the quantity selector when the shopper could pick more than one.
       Single-stock (or untracked-but-you-want-it-simple) cards just show ATC. */
    function updateQtyVisibility() {
      const qtyBox = ROOT.querySelector('.nb-qty');
      if (!qtyBox) return;
      const mx = maxQty();
      const showStepper = mx > 1;
      qtyBox.style.display = showStepper ? '' : 'none';
      if (!showStepper) { const i = $('qVal'); if (i) i.value = 1; }
    }

    /* Max quantity a shopper may add from quick-view right now: live stock
       minus the quantity already in cart. Oversell/untracked variants stay open. */
    function maxQty() {
      if (!selVar) return 99;
      if (selVar.oversell) return 99;
      if (typeof selVar.stock === 'number') {
        const inCart = parseInt(selVar.inCart || 0, 10) || 0;
        return Math.max(0, selVar.stock - inCart);
      }
      return 99;
    }
    function syncQuickAddState() {
      const btn = $('qvAtc');
      if (!btn || !selVar) return;
      const mx = maxQty();
      btn.disabled = !selVar.available || mx <= 0;
      if (btn.textContent !== 'Adding…') btn.textContent = (selVar.available && mx > 0) ? 'Add to cart' : 'Out of stock';
    }
    function clampQty() {
      const input = $('qVal');
      if (!input) return;
      let v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) v = 1;
      const mx = maxQty();
      const adjusted = v > mx;
      if (adjusted) v = mx > 0 ? mx : 1;
      input.value = v;
      if (mx !== 99) input.max = String(mx); else input.removeAttribute('max');
      /* reflect the cap on the UI */
      const up = ROOT.querySelector('[data-step="up"]');
      const down = ROOT.querySelector('[data-step="down"]');
      if (up) up.disabled = mx <= 0 || v >= mx;
      if (down) down.disabled = v <= 1;
      const note = $('qvStockNote');
      if (note) {
        if (!selVar.oversell && typeof selVar.stock === 'number') {
          if (selVar.stock <= 0) note.textContent = 'This card is currently out of stock.';
          else if (mx <= 0) note.textContent = stockText(selVar.stock) + ' — already in your cart.';
          else if (adjusted) note.textContent = stockText(selVar.stock) + '. Quantity has been adjusted.';
          else note.textContent = stockText(selVar.stock);
          note.hidden = false;
        } else { note.hidden = true; }
      }
    }

    if ($('qvPrev')) $('qvPrev').addEventListener('click', () => qvNav(-1));
    if ($('qvNext')) $('qvNext').addEventListener('click', () => qvNav(1));
    document.addEventListener('keydown', (e) => {
      if (!$('qvBack') || !$('qvBack').classList.contains('open')) return;
      if (/^(INPUT|SELECT|TEXTAREA)$/.test(e.target.tagName)) return;
      if (e.key === 'ArrowLeft') { e.preventDefault(); qvNav(-1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); qvNav(1); }
    });

    if (QUICKVIEW) {
      ROOT.addEventListener('click', e => {
        if (e.target.closest && e.target.closest('.nb-want')) return;
        const p = e.target.closest('.nb-pocket[data-id]');
        if (p && !p.classList.contains('is-sold')) openQV(+p.dataset.id, p);
      });
      ROOT.addEventListener('keydown', e => {
        if (e.key === 'Escape') closeQV();
        if (e.key === 'Enter') {
          if (e.target.closest && e.target.closest('.nb-want')) return;
          const p = e.target.closest && e.target.closest('.nb-pocket[data-id]');
          if (p) openQV(+p.dataset.id, p);
        }
      });
      /* qty stepper +/- and manual typing, both stock-clamped */
      ROOT.addEventListener('click', e => {
        const step = e.target.closest('[data-step]');
        if (!step) return;
        e.preventDefault();
        e.stopPropagation();
        const input = $('qVal');
        let v = parseInt(input.value, 10) || 1;
        v += (step.dataset.step === 'up' ? 1 : -1);
        input.value = Math.max(1, v);
        clampQty();
      });
      const qInput = $('qVal');
      if (qInput) {
        qInput.addEventListener('input', clampQty);
        qInput.addEventListener('blur', clampQty);
      }
      $('qvClose').addEventListener('click', closeQV);
      const explainBtn = $('condExplainBtn');
      if (explainBtn) {
        explainBtn.addEventListener('click', () => {
          const open = explainBtn.getAttribute('aria-expanded') === 'true';
          explainBtn.setAttribute('aria-expanded', String(!open));
          const detail = $('condDetail');
          if (detail) detail.hidden = open;
          const lbl = $('condExplainLabel');
          if (lbl) lbl.textContent = open ? 'What does this mean?' : 'Hide details';
        });
      }
      $('qvBack').addEventListener('click', e => { if (e.target === $('qvBack')) closeQV(); });
      initSheetDrag();
      $('qvAtc').addEventListener('click', async () => {
        if (!qvCard || !selVar) return;
        $('qvAtc').disabled = true; $('qvAtc').textContent = 'Checking stock…';
        if (!qvCard.stockChecked || (typeof selVar.stock !== 'number' && !selVar.oversell)) {
          await fetchLiveStock(qvCard);
        }
        await hydrateCartQuantities(qvCard);
        $('qvAtc').disabled = false;
        clampQty();
        const want = Math.max(1, parseInt($('qVal').value, 10) || 1);
        const mx = maxQty();
        if (mx <= 0) {
          $('qvAtc').textContent = 'Add to cart';
          const note = $('qvStockNote');
          if (note) {
            note.textContent = (!selVar.oversell && typeof selVar.stock === 'number' && selVar.stock > 0)
              ? stockText(selVar.stock) + ' — already in your cart.'
              : 'This card is currently out of stock.';
            note.hidden = false;
          }
          syncQuickAddState();
          return;
        }
        if (want > mx) {
          const note = $('qvStockNote'); if (note) { note.textContent = 'Only ' + mx + ' more can be added. Quantity has been adjusted.'; note.hidden = false; }
          const input = $('qVal'); if (input) input.value = mx > 0 ? mx : 1;
          $('qvAtc').textContent = 'Add to cart';
          syncQuickAddState();
          return;
        }
        $('qvAtc').disabled = true; $('qvAtc').textContent = 'Adding…';
        try {
          await NB.cartAdd(selVar.id, want);
          $('qvAtc').textContent = 'Added \u2713';
          setTimeout(closeQV, 600);
        } catch (err) {
          const note = $('qvStockNote');
          if (note) { note.textContent = (err && err.message) ? err.message : 'We couldn’t add that quantity. There may not be enough stock available.'; note.hidden = false; }
          $('qvAtc').textContent = 'Couldn\u2019t add \u2014 try again';
          $('qvAtc').disabled = false;
        }
      });
    }

    window.addEventListener('resize', render);
    loadProducts();
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-nb-binder]').forEach(initBinder);
  });
})();
